import { styled } from "simplydo/react/styled";
import { Dropdown } from "simplydo/react/ui/dropdown";
import { Input } from "simplydo/react/ui/input";
import { TextArea } from "simplydo/react/ui/textarea";

export const StyledLabel = styled.label`
  display: block;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1em;
  font-weight: 700;
  text-transform: none;

  &.is-required::after {
    content: " *";
    color: #db2828;
  }
`;

export const StyledField = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.3rem 0;
  min-width: 0;

  > :last-child:not(:only-child),
  > ${Input}, > ${Dropdown}, > ${TextArea} {
    margin-top: 0.3rem;
  }

  ${Input}, ${Dropdown}, ${TextArea} {
    display: flex;
    width: 100%;
    min-width: 0;
  }

  &.is-disabled {
    opacity: 0.45;
    pointer-events: none;
  }

  &.is-required > ${StyledLabel}::after {
    content: " *";
    color: #db2828;
  }

  &.is-error > ${StyledLabel} {
    color: #9f3a38;
  }

  &.is-error input,
  &.is-error textarea,
  &.is-error ${Dropdown} {
    background: #fff6f6 !important;
    border-color: #e0b4b4 !important;
    color: #9f3a38 !important;
  }
`;

export const ErrorLabel = styled.div`
  color: #9f3a38;
  margin-top: 0.3em;
  font-size: 0.875em;
`;
